export default "__VITE_ASSET__C9MrjE64__"